var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 2668,
    transform: "translate(-1525 -122)",
    fill: "#FBFBFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1765 -2.5H31.8235C38.8309 -2.5 44.5 3.10278 44.5 10C44.5 16.8972 38.8309 22.5 31.8235 22.5H10.1765C3.16907 22.5 -2.5 16.8972 -2.5 10C-2.5 3.10278 3.16907 -2.5 10.1765 -2.5Z",
    fill: "white",
    stroke: "#6E7E91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8236 -2.53577H10.1766C3.15932 -2.53577 -2.5293 3.07666 -2.5293 9.99995C-2.5293 16.9232 3.15932 22.5357 10.1766 22.5357H31.8236C38.8409 22.5357 44.5295 16.9232 44.5295 9.99995C44.5295 3.07666 38.8409 -2.53577 31.8236 -2.53577Z",
    fill: "#E5E5E5",
    stroke: "#D1D5DA",
    strokeOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#6E7E91"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99989 5.7179C7.63495 5.7179 5.71777 7.63507 5.71777 10C5.71777 12.365 7.63495 14.2821 9.99989 14.2821C12.3648 14.2821 14.282 12.365 14.282 10C14.282 7.63507 12.3648 5.7179 9.99989 5.7179ZM9.99989 13.5V6.50002C11.6617 6.4956 13.0949 7.6667 13.4217 9.29611C13.526 9.75959 13.526 10.2404 13.4217 10.7039C13.0949 12.3334 11.6617 13.5045 9.99989 13.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4412 6.55866C13.5134 6.63235 13.6118 6.67449 13.7149 6.67599C13.8181 6.67453 13.9165 6.63235 13.9887 6.55866L14.9468 5.60056C15.1196 5.47095 15.1546 5.22585 15.025 5.05306C14.8954 4.88026 14.6503 4.84527 14.4775 4.97484C14.4478 4.99707 14.4215 5.02341 14.3993 5.05306L13.4412 6.01116C13.29 6.14986 13.2799 6.38489 13.4186 6.53605C13.4258 6.54391 13.4333 6.55144 13.4412 6.55866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48036 13.4415C6.34132 13.3372 6.15011 13.3372 6.01107 13.4415L5.05297 14.3996C4.90177 14.5383 4.89167 14.7733 5.03041 14.9245C5.03759 14.9323 5.04515 14.9399 5.05297 14.9471C5.19167 15.0983 5.42671 15.1084 5.57787 14.9696C5.58573 14.9624 5.59325 14.9549 5.60044 14.9471L6.55854 13.9889C6.68815 13.8162 6.65315 13.5711 6.48036 13.4415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9471 14.3995L13.989 13.4414C13.8162 13.3118 13.5711 13.3468 13.4415 13.5196C13.3372 13.6587 13.3372 13.8499 13.4415 13.9889L14.3996 14.947C14.5383 15.0982 14.7733 15.1083 14.9245 14.9696C14.9323 14.9624 14.9399 14.9548 14.947 14.947C15.0982 14.8083 15.1083 14.5733 14.9696 14.4221C14.9625 14.4142 14.9549 14.4067 14.9471 14.3995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.01095 6.55866C6.14965 6.70986 6.38468 6.71997 6.53585 6.58123C6.54371 6.57404 6.55123 6.56648 6.55842 6.55866C6.70962 6.41996 6.71972 6.18493 6.58098 6.03377C6.5738 6.02591 6.56624 6.01838 6.55842 6.0112L5.60031 5.0531C5.42752 4.92349 5.18242 4.95852 5.05281 5.13132C4.94854 5.27035 4.94854 5.46156 5.05281 5.6006L6.01095 6.55866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99995 5.13129C10.2159 5.13129 10.391 4.95621 10.391 4.74023V3.39106C10.391 3.17508 10.2159 3 9.99995 3C9.78396 3 9.60889 3.17508 9.60889 3.39106V4.74023C9.60889 4.95621 9.78396 5.13129 9.99995 5.13129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99995 14.8688C9.78396 14.8688 9.60889 15.0439 9.60889 15.2598V16.609C9.60889 16.825 9.78396 17.0001 9.99995 17.0001C10.2159 17.0001 10.391 16.825 10.391 16.609V15.2598C10.391 15.0439 10.2159 14.8688 9.99995 14.8688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6089 9.60901H15.2597C15.0437 9.60901 14.8687 9.78409 14.8687 10.0001C14.8687 10.2161 15.0437 10.3911 15.2597 10.3911H16.6089C16.8249 10.3911 16.9999 10.2161 16.9999 10.0001C16.9999 9.78409 16.8248 9.60901 16.6089 9.60901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.13129 10.0001C5.13129 9.78409 4.95621 9.60901 4.74023 9.60901H3.39106C3.17508 9.60901 3 9.78409 3 10.0001C3 10.2161 3.17508 10.3911 3.39106 10.3911H4.74023C4.95621 10.3911 5.13129 10.2161 5.13129 10.0001Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 26,
    fill: "white",
    transform: "translate(-3 -3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.6ebddc9736532584547328069c28e37c.svg";
export { ForwardRef as ReactComponent };